module.exports = __webpack_public_path__ + "static/media/ELS30PG01.9a84e9be.png";